class VolumeDiscount extends HTMLElement {
  constructor() {
    super();
    this.bundlerLoaded = false;
    this.checkInterval = null;
    this.mutationObserver = null;
    this.isProcessing = false;
    this.eventListenersAdded = false;
  }

  connectedCallback() {
    // Immediately disable scroll animations on parent to prevent reset on scroll
    const parent = this.closest('.scroll-trigger');
    if (parent) {
      parent.classList.add('scroll-trigger--cancel');
      parent.classList.remove('scroll-trigger--offscreen');
    }

    this.checkForBundler();
  }

  checkForBundler() {
    const bundlerTarget = this.querySelector('.bundler-target-element-volume-discounts');

    if (bundlerTarget && bundlerTarget.querySelector('.bndlr-volume-discounts')) {
      this.initVolumeDiscounts();
    } else {
      // Check every 500ms for bundler app to load
      this.checkInterval = setInterval(() => {
        const target = this.querySelector('.bundler-target-element-volume-discounts');
        if (target && target.querySelector('.bndlr-volume-discounts')) {
          clearInterval(this.checkInterval);
          this.initVolumeDiscounts();
        }
      }, 500);

      // Stop checking after 10 seconds
      setTimeout(() => {
        if (this.checkInterval) {
          clearInterval(this.checkInterval);
        }
      }, 10000);
    }
  }

  initVolumeDiscounts() {
    if (!this.bundlerLoaded) {
      this.classList.add('bundler-loaded');
      this.bundlerLoaded = true;
      this.setupMutationObserver();
    }

    const discountElements = this.querySelectorAll('[data-quantity]');
    const quantityInput = document.querySelector('.quantity__input[name="quantity"]');

    if (!quantityInput) {
      return;
    }

    // Add images to discount elements
    this.addImagesToDiscounts(discountElements);

    // Only add event listeners once
    if (this.eventListenersAdded) {
      return;
    }
    this.eventListenersAdded = true;

    discountElements.forEach((element) => {
      // Make elements tappable on iOS
      element.style.cursor = 'pointer';

      const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const quantity = element.dataset.quantity;

        // Remove active class from all discount options
        discountElements.forEach(el => el.classList.remove('active'));

        // Add active class to clicked option
        element.classList.add('active');

        // Update quantity input value
        quantityInput.value = quantity;

        // Set the value property directly (iOS Safari fix)
        quantityInput.setAttribute('value', quantity);

        // Create native-like events for better iOS compatibility
        try {
          const inputEvent = new InputEvent('input', { bubbles: true, cancelable: true });
          quantityInput.dispatchEvent(inputEvent);
        } catch (e) {
          quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

        try {
          const changeEvent = new Event('change', { bubbles: true, cancelable: true });
          quantityInput.dispatchEvent(changeEvent);
        } catch (e) {
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Manually trigger any Shopify quantity handlers
        if (typeof quantityInput.onchange === 'function') {
          quantityInput.onchange();
        }
        if (typeof quantityInput.oninput === 'function') {
          quantityInput.oninput();
        }
      };

      element.addEventListener('touchstart', handleClick, { passive: false });
      element.addEventListener('click', handleClick);
    });

    // Set first option as active by default
    if (discountElements.length > 0) {
      discountElements[0].classList.add('active');
    }
  }

  setupMutationObserver() {
    // Watch for DOM changes in the bundler container
    const bundlerTarget = this.querySelector('.bundler-target-element-volume-discounts');
    if (!bundlerTarget) {
      return;
    }

    let debounceTimer = null;

    this.mutationObserver = new MutationObserver(() => {
      // Clear previous debounce timer
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }

      // Debounce to wait for all Bundler changes to complete
      debounceTimer = setTimeout(() => {
        // Prevent infinite loop
        if (this.isProcessing) {
          return;
        }

        // Check if bundler content was actually replaced (not our own changes)
        const hasDiscountElements = bundlerTarget.querySelector('.bndlr-volume-discounts');
        const hasCustomization = bundlerTarget.querySelector('.l-label');

        if (hasDiscountElements && !hasCustomization) {
          this.isProcessing = true;
          this.eventListenersAdded = false;

          // Disconnect observer before re-applying
          this.mutationObserver.disconnect();

          this.initVolumeDiscounts();
          this.isProcessing = false;

          // Reconnect observer after a short delay
          setTimeout(() => {
            this.mutationObserver.observe(bundlerTarget, {
              childList: true,
              subtree: true
            });
          }, 500);
        }
      }, 100); // Wait 100ms for Bundler to finish all changes
    });

    this.mutationObserver.observe(bundlerTarget, {
      childList: true,
      subtree: true
    });
  }

  addImagesToDiscounts(discountElements) {
    discountElements.forEach((element, index) => {
      const imageIndex = index + 1;
      const imageUrl = this.dataset[`image-${imageIndex}`];

      // Skip if already restructured
      if (element.querySelector('.l-label')) {
        return;
      }

      // Mark element as being customized to prevent bundler from touching it
      element.setAttribute('data-customized', 'true');

      // Create label span
      const label = document.createElement('span');
      label.className = 'l-label';

      // Create image container
      const imgContainer = document.createElement('div');
      imgContainer.className = 'l-img';

      if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = `Volume discount ${imageIndex}`;
        imgContainer.appendChild(img);
      }

      // Wrap existing content in text container
      const textContainer = document.createElement('div');
      textContainer.className = 'l-text';

      // Move all existing children to text container
      while (element.firstChild) {
        textContainer.appendChild(element.firstChild);
      }

      // Create variant badge
      const badge = document.createElement('span');
      badge.textContent = 'Sehr beliebt';
      badge.className = 'variant-badge';

      // Append in order: label, image, text, badge
      element.appendChild(label);
      element.appendChild(imgContainer);
      element.appendChild(textContainer);
      element.appendChild(badge);
    });
  }

  disconnectedCallback() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }
}

customElements.define('volume-discount', VolumeDiscount);